import React from "react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import strings from "../../helpers/Localization";

import Modal from "../Modal/Modal";

const pastMonth = new Date();
const customWeekDays = ["D", "L", "M", "M", "J", "V", "S"];
const currentDate = new Date();
const tomorrow = new Date(currentDate);
tomorrow.setDate(currentDate.getDate() + 1);
const dateInOneYear = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate());
const cdisabledDays = [
    { from: tomorrow, to: dateInOneYear }
];

const DatePicker = ({ open, onClose, onValidate, blockFutureDates, disabledDays, title }) => {
    const [range, setRange] = React.useState( {
        from: null,
        to: null
    });

    const resetRange = () => {
        setTimeout(() => {
            setRange({
                from: null,
                to: null
            });
        }, 2000);
    };

    return <Modal open={open}
        widthModalPaper={"400px"}
        heightModalBody={"auto"}
        onClose={() => {
            resetRange();
            onClose();
        }}
        onValidate={() => {
            let ed = range.to;
            if (ed) {
                ed.setHours(23, 59, 0, 0);
            }
            else {
                const ef = new Date(range.from);
                ef.setHours(23, 59, 0, 0);
                range.from.setHours(0, 1, 0, 0);
                ed = ef;
            }
            const startDate = format(range.from, "yyyy-MM-dd HH:mm:ss");
            const endDate = format(ed, "yyyy-MM-dd HH:mm:ss");
            onValidate({
                startDate: range.from <= ed ? startDate : endDate,
                endDate: range.from <= ed ? endDate : startDate
            });
            resetRange();
        }}
        title={title ? title : strings.period}
        icon={"calendar"}
    >
        <DayPicker
            id="date-picker-container"
            locale={{
                ...fr,
                localize: {
                    ...fr.localize,
                    day: (n) => customWeekDays[n]
                }
            }}
            mode="range"
            defaultMonth={pastMonth}
            showOutsideDays
            selected={range}
            onSelect={(rnge) => {
                if (rnge) {setRange(rnge);}
            }}
            disabled={ disabledDays ? disabledDays : blockFutureDates ? cdisabledDays : null}
            modifiers={{ start: range.from, end: range.to }}
        />
    </Modal>;
};

export default DatePicker;
